import { permissionsToLabels } from "../../constants/delegationPermissions";

interface DelegationPermissionBadgesProps {
  permissions: number;
}

const DelegationPermissionBadges = ({
  permissions,
}: DelegationPermissionBadgesProps) => {
  const labels = permissionsToLabels(permissions);

  if (labels.length === 0) {
    return <span className="text-muted">Ingen rettigheder</span>;
  }

  return (
    <ul className="list-unstyled d-flex flex-wrap gap-1 mb-0">
      {labels.map((label) => (
        <li key={label}>
          <span className="badge badge-light">{label}</span>
        </li>
      ))}
    </ul>
  );
};

export default DelegationPermissionBadges;
